import type { Ref } from 'vue';

import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IDownloadListReportPayload } from '@modules/download-report/types';

import useDownloadReportToast from './useDownloadReportToast';

export interface DownloadReportComposable {
  isReportLoading: Ref<boolean>;
  onDownloadReport(): Promise<void>;
}

export default function useDownloadReport(
  mutation: IContextMutationResult<void, Error, IDownloadListReportPayload>,
  tableState: Ref<IDownloadListReportPayload>,
): DownloadReportComposable {
  const { showToast } = useDownloadReportToast();

  const {
    isLoading: isReportLoading,
    mutateAsync: downloadReport,
  } = mutation;

  async function onDownloadReport(): Promise<void> {
    await downloadReport({ ...tableState.value });

    showToast();
  }

  return {
    isReportLoading,
    onDownloadReport,
  };
}
